export default __webpack_public_path__ + "static/media/user.223e56c3.png";